module.exports = __webpack_public_path__ + "img/loading_estrategia.05eea3fa.gif";